import { useMemo } from "react";
import { generateLibraryCodePreviewWithGame } from "@/lib/integrations/libraryCodePreview";
import { WizardMode, ViewDisplayMode } from "../types";

interface UseCodePreviewGeneratorProps {
  wizardMode: WizardMode;
  viewDisplayMode: ViewDisplayMode;
  initialData: any;
  gameId: any;
}

/**
 * Hook to generate code previews for different platforms
 * Handles Unity, Godot, C++, TypeScript, Roblox, and JSON exports
 */
export function useCodePreviewGenerator({
  wizardMode,
  viewDisplayMode,
  initialData,
  gameId,
}: UseCodePreviewGeneratorProps) {
  const codePreview = useMemo(() => {
    if (
      wizardMode !== "view" ||
      viewDisplayMode === "structured" ||
      viewDisplayMode === "documentation"
    ) {
      return null;
    }

    if (!initialData || !gameId) {
      return null;
    }

    try {
      if (viewDisplayMode === "json") {
        // Generate JSON preview of the library object
        return JSON.stringify(initialData, null, 2);
      }

      // Use the new export template system for code generation
      return generateLibraryCodePreviewWithGame(
        initialData,
        gameId,
        viewDisplayMode as any
      );
    } catch (error) {
      console.error("Error generating code preview:", error);
      return `// Error generating preview: ${
        error instanceof Error ? error.message : "Unknown error"
      }`;
    }
  }, [wizardMode, viewDisplayMode, initialData, gameId]);

  return { codePreview };
}

